import service from '../utils/Service'

export default function loginAction(email, password) {
   return {
      type : "LOGIN",
      payload: service.login(email, password)
   }
}




// WEBPACK FOOTER //
// ./src/actions/loginAction.js